import axios from 'axios'

axios.defaults.withCredentials = true
axios.defaults.headers = { 'Content-Type': 'text/plain' }

export default axios
